import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faCog } from '@fortawesome/pro-duotone-svg-icons';
import { IBrickDescription } from '../../../../store/dashboard/brick-wall/brick-instances/brick-instances.state';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import _ from 'lodash';
import { CloseBrickSettingsDialog, OpenBrickSettingsDialog } from '../../../../store/dashboard/brick-wall/brick-settings/brick-settings.actions';
import { BrickSettingsState } from '../../../../store/dashboard/brick-wall/brick-settings/brick-settings.state';
import { BrickInstancesSelectors } from '../../../../store/dashboard/brick-wall/brick-instances/brick-instances.selectors';

@Component({
   selector: 'samweb-brick-setting-button',
   templateUrl: './brick-setting-button.component.html',
   styleUrls: ['./brick-setting-button.component.scss'],
})
export class BrickSettingButtonComponent implements OnInit {
   @Input()
   public brickInstanceId: string;

   public settingsIcon: IconDefinition = faCog;

   public isBrickSettingAvailable$: Observable<boolean>;

   public isBrickSettingsDialogOpened$: Observable<boolean>;

   private brickInstanceDescription$: Observable<IBrickDescription>;

   constructor(private store: Store) {}

   ngOnInit() {
      this.isBrickSettingsDialogOpened$ = this.store.select(BrickSettingsState.isBrickSettingDialogOpenForBrickInstance(this.brickInstanceId));

      this.brickInstanceDescription$ = this.store.select(BrickInstancesSelectors.brickDescriptionFn).pipe(map((fn) => fn(this.brickInstanceId)));
      this.isBrickSettingAvailable$ = this.brickInstanceDescription$.pipe(
         map((x) => !_.isNil(x) && !_.isNil(x.definition) && !x.definition.disallowBrickSettings)
      );
   }

   @HostListener('click')
   openBrickSettingsDialog() {
      const isSettingsOpen = this.store.selectSnapshot(BrickSettingsState.isBrickSettingDialogOpenForBrickInstance(this.brickInstanceId));
      if (isSettingsOpen) {
         this.store.dispatch(new CloseBrickSettingsDialog(true));
      } else {
         this.store.dispatch(new OpenBrickSettingsDialog(this.brickInstanceId));
      }
   }
}
